export default {
  sales: {
    Region: '区域',
    Customer: '客户',
    RegionName: '区域名称',
    CustomerName: '客户名称',
    ProvinceName: '省份名称',
    CityName: '城市名称',
    Year: '年份',
    YearMonth: '年月',
    TotalAmount: '总金额',
    UnpaidAmount: '未付金额',
    PaidAmount: '已付金额',
    ReturnAmount: '退款金额',
    WriteOffAmount: '核销金额',
    UnWriteOffAmount: '未核销金额',
    ValidAmount: '有效金额',
    ChooseRegion: '区域选择',
    Dealer: '经销商'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/sales.js